import { ModalCloseReason } from './types';

export const isModalComplete = (reason: ModalCloseReason) =>
  reason === ModalCloseReason.completeAction;
